import { type IntlShape } from 'react-intl-next';

import { getUserRecommendations } from '@atlaskit/smart-user-picker';

type ProductKeyType = 'confluence';

type GetOwnersProps = {
	cloudId: string;
	intl: IntlShape;
	maxNumberOfResults: number;
	productKey: ProductKeyType;
	query: string;
	userId: string;
};

export const getOwners = ({
	query,
	userId,
	cloudId,
	productKey,
	maxNumberOfResults,
	intl,
}: GetOwnersProps) => {
	const requestParams = {
		context: {
			contextType: 'owners',
			principalId: userId,
			productAttributes: {
				isEntitledConfluenceExternalCollaborator: true,
			},
			productKey,
			siteId: cloudId,
		},
		includeGroups: false,
		includeTeams: false,
		includeUsers: true,
		maxNumberOfResults,
		performSearchQueryOnly: false,
		query,
	};

	return getUserRecommendations(requestParams, intl);
};
